<app-filter-dropdown
  name="status"
  [value]="statusValue()"
  [placeholder]="'modules.filter.allStatuses' | translate"
  [options]="statusDropdownOptions()"
  (valueChange)="onChange('status', $event)"
/>

<app-filter-dropdown
  name="author"
  [value]="authorValue()"
  [placeholder]="'modules.filter.allAuthors' | translate"
  [options]="authorDropdownOptions()"
  (valueChange)="onChange('author', $event)"
/>

@if (hasActiveFilters()) {
  <app-reset-filter-button [label]="'modules.filter.reset' | translate" (resetClick)="resetFilters.emit()" />
}

<app-saved-views-menu
  [views]="savedViews()"
  [activeName]="activeSavedView()"
  [context]="'MODULES'"
  [projectId]="projectId()"
  (viewSelected)="onSavedViewSelected($event)"
  (viewSaved)="onSavedViewSaved($event)"
  (viewDeleted)="onSavedViewDeleted($event)"
  (viewDeleteFailed)="onSavedViewDeleteFailed($event)"
/>
